import { useState } from 'react'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCreateReviewTemplate } from 'hooks/queries/reviewTemplates/useCreateReviewTemplate'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ReviewTemplateFormModalProps, TemplateSubmissionFields } from './Types'
import { useModals } from 'almanac-ui/Modal'

// TODO: Deprecate [visible, setVisible] in https://linear.app/almanac/issue/RAD-2489/create-new-templates-createupdate-modal
export const useNewReviewTemplateModalProps = (): ReviewTemplateFormModalProps => {
  const [visible, setVisible] = useState(false)
  const workspaceId = useCurrentWorkspaceId()
  const { closeModal } = useModals()
  const { mutate: createTemplate } = useCreateReviewTemplate({ workspaceId })
  const onSubmit = (template: TemplateSubmissionFields) => {
    const onSuccess = () => {
      showToastMessage('New Template Created')
      setVisible(false)
      closeModal()
    }
    const onError = () => {
      showToastMessage('Failed to save Template', 'error')
      setVisible(false)
      closeModal()
    }
    createTemplate(template, { onError, onSuccess })
  }

  return {
    visible,
    setVisible,
    onSubmit,
  }
}
